import { Button } from 'components/Button/Button';
import Checkbox from 'components/Checkbox/Checkbox';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const ContactFormActions = ({ onClose }: any) => {
    const { t } = useTranslation('forms');
    const { control, trigger } = useFormContext();
    return (
        <div className="flex mt-8 justify-between">
            <div className="flex gap-4">
                <Controller
                    control={control}
                    name="billToThisContact"
                    defaultValue={false}
                    render={({ field: { onChange, value } }) => (
                        <Checkbox onChange={onChange} checked={value}>
                            {t('billToThisContact')}
                        </Checkbox>
                    )}
                />
                <Controller
                    control={control}
                    name="monthlyConsumptionOverview"
                    defaultValue={false}
                    render={({ field: { onChange, value } }) => (
                        <Checkbox
                            onChange={checked => {
                                onChange(checked);
                                // Re-trigger email validation when checkbox changes
                                setTimeout(() => trigger('email'), 0);
                            }}
                            checked={value}
                        >
                            {t('monthlyConsumption')}
                        </Checkbox>
                    )}
                />
                <Controller
                    control={control}
                    name="receiveInvoiceCopy"
                    defaultValue={false}
                    render={({ field: { onChange, value } }) => (
                        <Checkbox onChange={onChange} checked={value}>
                            {t('receiveInvoiceCopy')}
                        </Checkbox>
                    )}
                />
            </div>
            <div className="flex justify-end gap-2">
                <Button variant="outline" type="button" onClick={onClose}>
                    {t('cancelButton')}
                </Button>
                <Button type="submit">{t('confirmButton')}</Button>
            </div>
        </div>
    );
};
